import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState, useEffect } from 'react';
import { consentCookieHelper } from '@sainsburys-tech/boltui-utils';
import useInterval from './useInterval';

function useCookieConsent(category) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      hasConsent = _useState2[0],
      setHasConsent = _useState2[1];

  var setCookieConsent = function setCookieConsent() {
    var cookies = global.document.cookie;
    var consentCookieValue = consentCookieHelper.getConsentCookieValue(cookies);

    if (consentCookieValue === '') {
      return setHasConsent(null);
    } // Set opted out in case invalid cookie value or invalid category passed in


    if (!consentCookieValue.includes('consent:') || !consentCookieHelper.categories[category]) {
      return setHasConsent(false);
    }

    var categorySection = consentCookieHelper.getCategorySection(consentCookieValue, category); // If can't find section, then all cookies were accepted (example value: 'ts:1575020721807|consent:true')

    if (!categorySection.length && consentCookieValue.includes('consent:true')) {
      return setHasConsent(true);
    }

    return setHasConsent(consentCookieHelper.hasOptedIn(categorySection[0]));
  }; // Get cookie on mount


  useEffect(function () {
    setCookieConsent();
  }, []); // Check for cookie value every second if no value

  useInterval(function () {
    setCookieConsent();
  }, 1000, hasConsent !== null);
  return hasConsent;
}

export default useCookieConsent;